// 관리자 목록/상세에서 반복되는 천 단위 숫자 표시 형식을 한 곳에서 관리한다.
export const formatNumber = (value) => {
    return new Intl.NumberFormat().format(Number(value || 0))
}

// 통계처럼 값이 깨져도 화면에는 0으로 보여야 하는 영역에서 사용한다.
export const formatSafeNumber = (value) => {
    const nextNumber = Number(value) || 0

    return new Intl.NumberFormat().format(nextNumber)
}
